import { Tabs, Typography } from "antd";
import { useSearchParams } from "react-router-dom";
import CustomerIntelligenceTab from "./CustomerIntelligenceTab";
import MyOperatorTab from "./MyOperatorTab";
import QCTab from "./QCTab";

const { Title, Text } = Typography;

const TABS = [
  {
    key: "customers",
    label: "Customers",
    hint: "Who needs attention: orders, tickets and call sentiment per customer.",
    children: <CustomerIntelligenceTab />,
  },
  {
    key: "qc",
    label: "Calls Quality Analysis",
    hint: "Every analysed call with its QC score, sentiment, summary, recording and transcript — per call and per agent.",
    children: <QCTab />,
  },
  {
    key: "myoperator",
    label: "All MyOperator Calls",
    hint: "Raw telephony log for every team, including calls without a transcript.",
    children: <MyOperatorTab />,
  },
];

const CallIntelligence = () => {
  const [params, setParams] = useSearchParams();
  // old "Calls & Sentiment" links (?tab=calls) land on the merged tab
  const requested = params.get("tab") === "calls" ? "qc" : params.get("tab");
  const active = TABS.some((t) => t.key === requested) ? (requested as string) : "customers";
  const hint = TABS.find((t) => t.key === active)?.hint;

  return (
    <div style={{ padding: 16 }}>
      <Title level={3} style={{ marginBottom: 0 }}>
        Call Intelligence
      </Title>
      <Text type="secondary">{hint}</Text>
      <Tabs
        style={{ marginTop: 8 }}
        activeKey={active}
        onChange={(key) => setParams({ tab: key })}
        destroyInactiveTabPane
        items={TABS.map(({ key, label, children }) => ({ key, label, children }))}
      />
    </div>
  );
};

export default CallIntelligence;
